(() => {
  // Equalise headings within each visual row without truncating product names.
  let queued;
  function alignCards() {
    cancelAnimationFrame(queued);
    queued=requestAnimationFrame(() => {
      document.querySelectorAll('.product-grid, .contains-card--product').forEach(grid => {
        const cards=Array.from(grid.querySelectorAll('.product-card-wrapper'));
        cards.forEach(card=>card.style.removeProperty('--v22-title-height'));
        const rows=new Map();
        cards.forEach(card=>{
          const heading=card.querySelector('.card > .card__content .card__heading');
          if(!heading)return;
          const top=Math.round(card.getBoundingClientRect().top);
          const row=rows.get(top)||[];row.push({card,heading});rows.set(top,row);
        });
        rows.forEach(row=>{
          const height=Math.max(...row.map(({heading})=>heading.getBoundingClientRect().height));
          row.forEach(({card})=>card.style.setProperty('--v22-title-height',height+'px'));
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded',alignCards);
  window.addEventListener('resize',alignCards);
  document.addEventListener('shopify:section:load',alignCards);
  if(document.fonts)document.fonts.ready.then(alignCards);
  // Native cart section refreshes include new product cards after filtering.
  const main=document.getElementById('MainContent');
  if(main)new MutationObserver(alignCards).observe(main,{childList:true,subtree:true});
})();
